"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasRetinaScreen = void 0;

var _hasWindow = require("./has-window");

var MIN_DEVICE_MEDIA_QUERY = '(-webkit-min-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi), (min-resolution: 1.5dppx)';
/**
 * Safely, determine if the device has a retina screen
 */

var hasRetinaScreen = function hasRetinaScreen() {
  return _hasWindow.HAS_WINDOW && window.matchMedia(MIN_DEVICE_MEDIA_QUERY).matches;
};

exports.hasRetinaScreen = hasRetinaScreen;
//# sourceMappingURL=has-retina-screen.js.map